var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.662,
    cy: 8,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook_svg__b)",
    fillRule: "evenodd",
    d: "M.662 8c0 3.96 2.88 7.24 6.68 7.92l.04-.033V10.24h-2V8h2V6.24c0-2 1.28-3.12 3.12-3.12.56 0 1.2.08 1.76.16v2.04h-1.04c-.96 0-1.2.48-1.2 1.12V8h2.12l-.36 2.24h-1.76v5.673c3.78-.696 6.64-3.967 6.64-7.913 0-4.4-3.6-8-8-8s-8 3.6-8 8Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__b",
    x1: 8.663,
    x2: 8.663,
    y1: 15.444,
    y2: -0.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.662 0h16v16h-16z"
  })))));
};
export default SvgFacebook;